export default __webpack_public_path__ + "static/media/1934.0bd93ca6.png";